import { addDays, format } from 'date-fns'

export const getLocalizedDayNames = (locale: Locale) => {
	const dayNames = []
	for (let i = 1; i <= 7; i++) {
		const dayIndex = i % 7
		const date = addDays(new Date(2021, 0, 3), dayIndex)
		dayNames.push(format(date, 'EEEEEE', { locale }))
	}
	return dayNames
}
